export function formatSaveSimulatoLeadRequest(
  dwellingStepAnswers,
  requiredInfo,
  savingAnswers,
  aidsStepAnswers,
  mcpDpe
) {
  /* formatting the dwelling step simulator data */
  let requestData = {
    "from_simulator_advanced": 1,
    "prefix": requiredInfo.prefix,
    "lastname": requiredInfo.lastname,
    "firstname": requiredInfo.firstname,
    "email": requiredInfo.email,
    "billing[country_id]": "FR",
    "billing[street][]": [requiredInfo.adresse],
    "billing[city]": requiredInfo.city,
    "billing[postcode]": requiredInfo.postalcode,
    "billing[telephone]": requiredInfo.phone,
    "proxiserve_optin": requiredInfo.proxiserve_optin
  };

  requestData['mcp_intervention_code'] = requiredInfo.postalcode;

  // Estimated dpe
  if(mcpDpe) requestData['mcp_dpe'] = `E${mcpDpe}`;

  // Add dwelling form answers
  Object.keys(dwellingStepAnswers).forEach(key => {
    if(key === "mcp_home_ownership" && dwellingStepAnswers[`${key}`] == "home_owner_status") {
      requestData[`${key}`] = "home_owner";
    } else{
      requestData[`${key}`] = dwellingStepAnswers[`${key}`];
    }
  })

  // Add saving options recomandation answers
  Object.keys(savingAnswers).forEach(key => {
    requestData[`${key}`] = savingAnswers[`${key}`]
  })
  // Add aids form answers
  Object.keys(aidsStepAnswers).forEach(key => {
    requestData[`${key}`] = aidsStepAnswers[`${key}`]
  })
  
  /* preparing the form-data request */
  let bodyFormData = new FormData();
  
  Object.keys(requestData).forEach(key => {
    if (typeof requestData[key] === "string" || typeof requestData[key] === "number") {
      bodyFormData.append(key, requestData[key]);
    } else if (requestData[key] && typeof requestData[key] === "object" && requestData[key].length) {
      requestData[key].forEach(value => bodyFormData.append(key, value));
    } else if (typeof requestData[key] === "boolean") {
      bodyFormData.append(key, +requestData[key]); // transform into 0|1
    }
  });

  return bodyFormData;
}